import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector.js';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const NodueDeptupdate = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;




	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);
	const [cnt, setCnt] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);

	


	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage,setEntriesPerPage]=useState(10);
	let filteredItems = data.filter((item) =>



		`${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

	const [checkedItems, setCheckedItems] = useState({});

	const startIndex = (currentPage - 1) * entriesPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	// const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	// const handleRowsPerPageChange = (e) => {
	// 	setItemsPerPage(Number(e.target.value));
	// 	setCurrentPage(1); // Reset to first page
	// };



	useEffect(() => {
		axios.get(API_BASE_URL + '/nodue_dept_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then((res) =>{
				setData(res.data);
// 				const defaultChecked = {};
//   res.data.forEach(item => {
// 	if(item.hr_status_id == 1){
//     defaultChecked[item.id] = true;
// 	}
//   });
//   setCheckedItems(defaultChecked);
			}) 
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	

	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);




useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(API_BASE_URL + "/gethrExitListcnt", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        },
      });
      // console.log(response.data);
      
      setCnt(response.data);
      // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);





	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
									<div id="button">
										<button style={{ float: 'center' }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											onClick={()=>{setUser(emptyUser)}}
										>
											<i className="fe fe-plus mr-2" />
											Add
										</button>
									</div>
								</div>
							</div> */}

						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title" style={{ color: '#e96827' }}>Nodue List</h3>
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

												<div className="input-group">

													<EntriesSelector style={{
																padding: '1px',
																marginRight: '20px',
																borderRadius: '4px',
																border: '1px solid #ccc',
																backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
															  }}
														setEntriesPerPage={setEntriesPerPage}
														setCurrentPage={setCurrentPage}
													/>

													<div style={{ position: "relative", width: "300px" }}>

													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={e => {
																setSearchTerm(e.target.value);
																setCurrentPage(1);
																}}
														style={{
															width: "100%",
															padding: "10px",
															paddingRight: "30px", // Extra space for the clear icon
															boxSizing: "border-box",
														  }}
														// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
													/>

 {searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
	    </div>



												</div>

											</div>
										</div>












										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															 
															<th>Action</th>
										
															<th>Employee</th>
															<th>Department</th>
															
															<th>Applied On</th>
															<th>Releaved On</th>
															
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((nodue, index) => {

																return <tr key={index}>

																	
																	<td className="d-flex">
  {(nodue.exit_procedure_count === 1 && new Date(nodue.current_date) >= new Date(nodue.nodue)) && (
    <Link to={`/Nodue-DeptWise?emp_id=${nodue.employee_id}`}>
      <i className="fe fe-maximize" />
    </Link>
  )}
</td>

																	
																	<td>
																		<span>{nodue.employee_name}</span>
																	</td>
																	<td>
																		<span>{nodue.department_name}</span>
																	</td>

																	<td>
																		<span>{nodue.applied_on}</span>
																	</td>


																	<td>
																		<span>{nodue.releaved_on}</span>
																	</td>

																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	

										</div>
										
										



									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>





			
			






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(NodueDeptupdate);